import { useAtomValue } from 'jotai';

import { LDFlags } from '../../../../../constants/flags';
import { useFlag } from '../../../../../hooks';
import { GetLeadByExternalId200 } from '../../../../../services/marketplace/generated/kubb/models/GetLeadByExternalId';
import { devGuidanceScenarioAtom } from '../../devToolbarAtoms';
import { DEV_GUIDANCE_SAMPLES } from '../devGuidanceSamples';
import { LeadGuidance, toLeadGuidance } from '../guidance';

const useLeadGuidance = (lead: GetLeadByExternalId200 | undefined): LeadGuidance | null => {
  const almostLiveEnabled = useFlag(LDFlags.MARKETPLACE_ALMOST_LIVE);
  const devGuidanceScenario = useAtomValue(devGuidanceScenarioAtom);
  if (!almostLiveEnabled) return null;
  if (devGuidanceScenario) return DEV_GUIDANCE_SAMPLES[devGuidanceScenario];
  return toLeadGuidance(lead?.listVsBuyout, lead?.gateDecision);
};

export default useLeadGuidance;
